import { SafeErrorBoundaries } from "@/utils/hooks/SafeErrorBoundaries/SafeErrorBoundaries.jsx";
import { routePaths } from "./routesPath";
import { UserSpace } from "@/pages/user-space/UserSpace";

export const protectedRoutes = [
    {
        path: routePaths.espace_user+'/*',
        element:
          <SafeErrorBoundaries> 
            <UserSpace />
          </SafeErrorBoundaries>,
     },
];